import { useMemo } from 'react';

import { Badge } from '@thefarmersfront/kitchen-mobile';

import { SPECIAL_MEDICAL_EXAMINATION_STATUS_LABEL } from '~/constants';
import { useUserInfoStore } from '~/store';

/** @description 특수건강검진 상태 배지 컴포넌트 */
const SpecialMedicalBadge = () => {
  const status = useUserInfoStore((state) => state.specialMedicalExamination?.status) ?? null;

  const getBadgeColor: 'error' | 'success' | 'secondary' = useMemo(() => {
    if (status?.code.includes('REJECTED')) {
      return 'error';
    }
    if (status?.code.includes('APPROVED')) {
      return 'success';
    }
    return 'secondary';
  }, [status]);

  const getBadgeText = useMemo(() => {
    if (!status?.code) {
      return '';
    }
    return SPECIAL_MEDICAL_EXAMINATION_STATUS_LABEL[status.code];
  }, [status]);

  return <Badge color={getBadgeColor} value={getBadgeText} variant="light" size="small" shape="capsule" />;
};

export default SpecialMedicalBadge;
